var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { AppBootstrapComponent } from "./components/AppBootstrapComponent";
import { BookingFormPage } from "./components/BookingFormPage";
import { Courses } from "./components/Courses/Courses";
import { SuccessPage } from "./components/Success/SuccessPage";
import { PaybookPage } from "./components/Paybook/PaybookPage";
import { PaybookIntermittentPage } from "./components/PaybookIntermittentPage/PaybookIntermittentPage";
import { ERoute } from "./helpers/Routes";
import { BankTransferPage } from "./components/BankTransferPage/BankTransferPage";
import { ConsentsPage } from "./components/ConsentsPage/ConsentsPage";
import { SepaDirectDebitPage } from "./components/Sepa/SepaDirectDebitPage";
import { CheckoutPage } from "./components/CheckoutPage/CheckoutPage";
import { CartPage } from "./components/Cart";
import { OutgoingMessagesPage } from "./components/OutgoingMessagesPage/OutgoingMessagesPage";
import { useConfig } from "./AppContext";
import { CancelBookingPage } from "./components/CancelBookingPage/CancelBookingPage";
import { CmsPage } from "./components/CMS/CMS";
import { AuthScreen } from "./Auth";
import { useIsUserAccountsEnabled } from "./Auth/rx/useIsUserAccountsEnabled";
import { PoweredByWrapper } from "./components/PoweredBy";
var WsRouterComponent = function (props) {
    var isCartDisabled = useConfig("disableCart", false)[0];
    var isUserAccountsEnabled = useIsUserAccountsEnabled();
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: "/" },
            React.createElement(Redirect, { to: ERoute.BOOKCART })),
        React.createElement(Route, { path: ERoute.BOOKCART },
            React.createElement(PoweredByWrapper, null,
                React.createElement(BookingFormPage, __assign({}, props)))),
        React.createElement(Route, { path: ERoute.COURSES },
            React.createElement(Courses, __assign({}, props))),
        React.createElement(Route, { path: ERoute.SUCCESS },
            React.createElement(PoweredByWrapper, null,
                React.createElement(SuccessPage, null))),
        React.createElement(Route, { exact: true, path: ERoute.PAYBOOK },
            React.createElement(PoweredByWrapper, null,
                React.createElement(PaybookPage, null))),
        React.createElement(Route, { path: ERoute.APPROVED },
            React.createElement(PaybookIntermittentPage, { isApproved: true })),
        React.createElement(Route, { path: ERoute.CANCELLED },
            React.createElement(PaybookIntermittentPage, { isApproved: false })),
        React.createElement(Route, { path: ERoute.BANK_TRANSFER },
            React.createElement(PoweredByWrapper, null,
                React.createElement(BankTransferPage, null))),
        React.createElement(Route, { path: ERoute.CONSENTS },
            React.createElement(PoweredByWrapper, null,
                React.createElement(ConsentsPage, null))),
        React.createElement(Route, { path: ERoute.SEPA_DIRECT_DEBIT },
            React.createElement(PoweredByWrapper, null,
                React.createElement(SepaDirectDebitPage, null))),
        !isCartDisabled &&
            React.createElement(Route, { path: ERoute.CART },
                React.createElement(PoweredByWrapper, null,
                    React.createElement(CartPage, __assign({}, props)))),
        !isCartDisabled &&
            React.createElement(Route, { path: ERoute.CHECKOUT },
                React.createElement(PoweredByWrapper, null,
                    React.createElement(CheckoutPage, __assign({}, props)))),
        React.createElement(Route, { path: ERoute.OUTGOING_MESSAGES },
            React.createElement(PoweredByWrapper, null,
                React.createElement(OutgoingMessagesPage, __assign({}, props)))),
        React.createElement(Route, { path: ERoute.CANCEL_BOOKING },
            React.createElement(PoweredByWrapper, null,
                React.createElement(CancelBookingPage, __assign({}, props)))),
        React.createElement(Route, { path: ERoute.CMS },
            React.createElement(CmsPage, __assign({}, props))),
        isUserAccountsEnabled &&
            React.createElement(Route, { path: ERoute.USER_ACCOUNT },
                React.createElement(PoweredByWrapper, null,
                    React.createElement(AuthScreen, null)))));
};
export var WsRouter = function (props) { return (React.createElement(AppBootstrapComponent, __assign({}, props, { Component: WsRouterComponent }))); };
